import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Books = () => {
  const apiURL = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.isAdmin || false;
  const [books, setBooks] = useState([]);
  const [activeTab, setActiveTab] = useState("cover");
  const [isLoading, setIsLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [coverFile, setCoverFile] = useState(null);
  const [telegramLink, setTelegramLink] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    axios.get(apiURL + "/books").then(r => setBooks(Array.isArray(r.data) ? r.data : [r.data])).catch(() => setBooks([])).finally(() => setIsLoading(false));
  }, [apiURL]);

  const uploadCover = async (file) => {
    const fd = new FormData(); fd.append("image", file);
    const r = await axios.post(apiURL + "/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return r.data.url;
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!title || !description || !category || !telegramLink || !coverFile) return alert("Please fill all fields");
    setUploading(true);
    try {
      const coverUrl = await uploadCover(coverFile);
      const r = await axios.post(apiURL + "/books", { title, description, category, cover: coverUrl, file: telegramLink, telegramLink }, { headers: { "Content-Type": "application/json" } });
      setBooks(p => [...p, r.data]);
      setTitle(""); setDescription(""); setCategory(""); setCoverFile(null); setTelegramLink("");
      document.getElementById("upload-form")?.reset();
      alert("Book uploaded!");
    } catch (err) { alert("Error: " + (err.response?.data?.error || err.message)); }
    finally { setUploading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete?")) return;
    try { await axios.delete(apiURL + "/books?id=" + id); setBooks(p => p.filter(b => (b._id || b.id) !== id)); } catch { alert("Delete failed."); }
  };

  const handleDownload = (book) => {
    const fileUrl = book.telegramLink || book.file;
    if (fileUrl && (fileUrl.includes("t.me/") || fileUrl.startsWith("tg:"))) {
      window.open(fileUrl, "_blank");
      return;
    }
    const filename = book.title + ".pdf";
    const proxyUrl = apiURL + "/download?url=" + encodeURIComponent(fileUrl) + "&name=" + encodeURIComponent(filename);
    const a = document.createElement("a"); a.href = proxyUrl; a.download = filename;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
  };

  const grouped = books.reduce((a, b) => { if (!a[b.category]) a[b.category] = []; a[b.category].push(b); return a; }, {});

  return (
    <div className="page-container books-theme">
      <div className="page-header"><h1 className="page-main-title"> መጻሕፍት</h1></div>
      {isAdmin && (
        <div className="content-container mt-2">
          <div className="content-header"><div className="content-icon"></div><h3 className="content-title">Upload New Book</h3></div>
          <form id="upload-form" onSubmit={handleUpload} className="space-y-3">
            <div className="controls-grid">
              <div className="control-group"><label className="control-label"> ርዕስ</label><input type="text" placeholder="ለምሳሌ- መጽሐፈ ሄኖክ..." value={title} onChange={e => setTitle(e.target.value)} className="control-input" required /></div>
              <div className="control-group"><label className="control-label"> ምድብ</label><input type="text" placeholder="ለምሳሌ- መጽሐፈ ቅዱሳን..." value={category} onChange={e => setCategory(e.target.value)} className="control-input" required /></div>
            </div>
            <div className="control-group"><label className="control-label"> መግለጫ</label><input type="text" placeholder="አጭር መግለጫ..." value={description} onChange={e => setDescription(e.target.value)} className="control-input" required /></div>
            <div className="control-group">
              <label className="control-label"> የቴሌግራም ሊንክ</label>
              <input type="url" placeholder="https://t.me/..." value={telegramLink} onChange={e => setTelegramLink(e.target.value)} className="control-input" required />
            </div>
            <div className="control-group"><label className="control-label"> የሽፋን ምስል</label><input type="file" accept="image/*" required onChange={e => setCoverFile(e.target.files[0])} className="control-input" /></div>
            <div className="flex gap-3">
              <button type="submit" disabled={uploading} className="btn-primary flex-1">{uploading ? "..." : " Upload"}</button>
              <button type="button" onClick={() => { setTitle(""); setDescription(""); setCategory(""); setCoverFile(null); setTelegramLink(""); document.getElementById("upload-form")?.reset(); }} className="btn-secondary"></button>
            </div>
          </form>
        </div>
      )}
      {!user && (
        <div className="text-center my-3">
          <button onClick={() => navigate("/login")} className="btn-secondary text-sm"> ለመጫን ይግቡ</button>
        </div>
      )}
      <div className="flex gap-2 my-3">
        {["cover","download"].map(t => <button key={t} onClick={() => setActiveTab(t)} className={"px-3 py-1.5 rounded-lg font-medium text-sm " + (activeTab===t?"bg-amber-500 text-white":"bg-gray-100 text-gray-600 hover:bg-gray-200")}>{t==="cover"?" መጻሕፍት":" ሁሉንም"}</button>)}
      </div>
      {isLoading && <div className="loading-container"><div className="loading-spinner"></div></div>}
      {activeTab==="cover" && (
        <div className="space-y-4">
          {Object.keys(grouped).length===0&&!isLoading?<div className="no-results"><p className="no-results-title">ምንም መጽሐፍ አልተገኘም</p></div>:
          Object.keys(grouped).map(cat=>(
            <div key={cat} className="content-container">
              <div className="content-header"><div className="content-icon"></div><h2 className="content-title">{cat}</h2></div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                {grouped[cat].map(book=>(
                  <div key={book._id||book.id} className="card-item flex flex-col">
                    {isAdmin&&<button onClick={()=>handleDelete(book._id||book.id)} className="text-xs text-red-500 mb-1 self-end"></button>}
                    <img src={book.cover} alt={book.title} className="w-full aspect-[3/4] object-cover rounded-lg mb-2" />
                    <h3 className="text-sm font-semibold leading-tight mb-1">{book.title}</h3>
                    <p className="text-xs text-gray-500 mb-2 flex-1">{book.description}</p>
                    <button onClick={()=>handleDownload(book)} className="btn-primary text-xs justify-center w-full"> አውርድ</button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      {activeTab==="download" && (
        <div className="content-container">
          <div className="content-header"><div className="content-icon"></div><h2 className="content-title">ሁሉም</h2></div>
          <div className="space-y-2">{books.map(book=>(
            <div key={book._id||book.id} className="flex items-center justify-between p-2 rounded-lg border border-gray-200">
              <div className="flex items-center gap-2"><img src={book.cover} alt={book.title} className="w-8 h-10 object-cover rounded" /><div><p className="font-medium text-sm">{book.title}</p><p className="text-xs text-gray-500">{book.category}</p></div></div>
              <button onClick={()=>handleDownload(book)} className="btn-primary text-xs"></button>
            </div>
          ))}</div>
        </div>
      )}
    </div>
  );
};

export default Books;